import DnaEffect from './DnaEffect'

export default DnaEffect
